var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgNotificationBellNotify = function SvgNotificationBellNotify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.927 16.807a8.925 8.925 0 01-2.264-6.308 6.452 6.452 0 00-5.228-6.34c0-1.574-.712-1.659-1.433-1.659-.722 0-1.18.085-1.18 1.64a6.49 6.49 0 00-5.227 6.359c0 4.18-1.476 5.456-2.267 6.303-.227.24-.353.558-.351.888a1.308 1.308 0 001.31 1.307H19.97a1.308 1.308 0 001.31-1.307c.001-.33-.126-.646-.353-.883z",
    fill: "url(#Notification_Bell_Notify_svg__paint0_radial_822_47902)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 7a3 3 0 013 3",
    stroke: "#fff",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 23c2.691 0 2.82-3 2.82-3H9s.808 3 3.5 3z",
    fill: "url(#Notification_Bell_Notify_svg__paint1_radial_822_47902)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Notification_Bell_Notify_svg__paint0_radial_822_47902",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.40869 12.82893 -14.25026 7.1187 5.72 6.168)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Notification_Bell_Notify_svg__paint1_radial_822_47902",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.2128 2.33294 -3.23647 3.06982 9.947 20.667)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076FF"
  })))));
};
export default SvgNotificationBellNotify;